export default __webpack_public_path__ + "static/media/notification.74fbcec7.svg";